import { motion } from "framer-motion";
import {
    Banknote,
    HeartPulse,
    Signal,
    ShoppingCart,
    Landmark,
    Rocket,
} from "lucide-react";
import { SectionHeader } from "./Services";

export const INDUSTRIES = [
    { icon: Banknote, name: "Finance", desc: "Investor sentiment, banking experience, payments." },
    { icon: HeartPulse, name: "Healthcare", desc: "Patient & HCP studies, access and adherence." },
    { icon: Signal, name: "Telecom", desc: "Network NPS, churn drivers, plan optimisation." },
    { icon: ShoppingCart, name: "E-commerce", desc: "Shopper journeys, post-purchase, returns." },
    { icon: Landmark, name: "Government", desc: "Public services research and citizen surveys." },
    { icon: Rocket, name: "Startups", desc: "PMF, pricing, ICP discovery, fast pulses." },
];

export default function Industries() {
    return (
        <section
            className="relative py-28"
            data-testid="industries-section"
        >
            <div className="pr-container">
                <SectionHeader
                    overline="Industries"
                    title="Insight, tuned to your sector"
                    subtitle="We've built playbooks across regulated and fast-moving industries — fielded across 12+ countries."
                />

                <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
                    {INDUSTRIES.map((ind, i) => {
                        const Icon = ind.icon;
                        return (
                            <motion.div
                                key={ind.name}
                                initial={{ opacity: 0, scale: 0.92 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.45, delay: i * 0.05 }}
                                className="pr-card rounded-2xl p-5 text-center group"
                                data-testid={`industry-card-${i}`}
                            >
                                <div className="w-12 h-12 mx-auto rounded-xl bg-blue-500/10 border border-blue-400/30 flex items-center justify-center group-hover:bg-emerald-500/10 group-hover:border-emerald-400/40 transition-colors">
                                    <Icon className="w-5 h-5 text-blue-300 group-hover:text-emerald-300 transition-colors" />
                                </div>
                                <p className="mt-4 font-outfit text-sm font-semibold text-white">
                                    {ind.name}
                                </p>
                                <p className="mt-1 text-[11px] text-slate-400 leading-relaxed">
                                    {ind.desc}
                                </p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
